const calcResizedPath = (uuid: string, paramString: string, canUseSpecialVersion = false) => {
  return `resized/${paramString}/${uuid}.${canUseSpecialVersion ? 'webp' : 'jpg'}`;
};

export const calcResizedUrl = (
  imagesEndpoint: string,
  uuid: string,
  paramString: string,
  canUseSpecialVersion = false
) => {
  return `${imagesEndpoint}/images/${calcResizedPath(uuid, paramString, canUseSpecialVersion)}`;
};

export const calcResizedPdfUrl = (
  assetsEndpoint: string,
  key: string, // pdf/2f9bf304-45f3-4447-958f-08243ab1575d/2f9bf304-45f3-4447-958f-08243ab1575d-page-1.jpeg
  paramString: string
) => {
  const pre = key.split('/').slice(0, 2); // pdf/2f9bf304-45f3-4447-958f-08243ab1575d
  const post = key.split('/').slice(2); // 2f9bf304-45f3-4447-958f-08243ab1575d-page-1.jpeg
  return `${assetsEndpoint}/assets/${pre.join('/')}/resized/${paramString}/${post.join('/')}`;
};
